import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-nss', templateUrl: './nss.component.html', styleUrls: ['./nss.component.scss'] })
export class NssComponent implements OnInit {

  nssImages = [
    '/assets/img/quick-links/nss/1 (1).jpg',
    '/assets/img/quick-links/nss/1 (2).jpg',
    '/assets/img/quick-links/nss/1 (3).jpg',
    '/assets/img/quick-links/nss/1 (4).jpg',
    '/assets/img/quick-links/nss/1 (5).jpg',
    '/assets/img/quick-links/nss/1 (6).jpg',
    '/assets/img/quick-links/nss/1 (7).jpg',
    '/assets/img/quick-links/nss/1 (8).jpg',
    '/assets/img/quick-links/nss/1 (9).jpg',
    '/assets/img/quick-links/nss/1 (10).jpg',
    '/assets/img/quick-links/nss/1 (11).jpg',
    '/assets/img/quick-links/nss/1 (12).jpg',
    '/assets/img/quick-links/nss/1 (13).jpg',
    '/assets/img/quick-links/nss/1 (14).jpg',
    '/assets/img/quick-links/nss/1 (15).jpg',
    '/assets/img/quick-links/nss/1 (16).jpg',
    '/assets/img/quick-links/nss/1 (17).jpg',
    '/assets/img/quick-links/nss/1 (18).jpg',
    '/assets/img/quick-links/nss/1 (19).jpg',
    '/assets/img/quick-links/nss/1 (20).jpg',
    '/assets/img/quick-links/nss/1 (21).jpg',
    '/assets/img/quick-links/nss/1 (22).jpg',
    '/assets/img/quick-links/nss/1 (23).jpg',
    '/assets/img/quick-links/nss/1 (24).jpg',
    '/assets/img/quick-links/nss/1 (25).jpg',
    '/assets/img/quick-links/nss/1 (26).jpg',
    '/assets/img/quick-links/nss/1 (27).jpg',
    '/assets/img/quick-links/nss/1 (28).jpg',
    '/assets/img/quick-links/nss/1 (29).jpg',
    '/assets/img/quick-links/nss/1 (30).jpg',
    '/assets/img/quick-links/nss/1 (31).jpg',
    '/assets/img/quick-links/nss/1 (32).jpg',
    '/assets/img/quick-links/nss/1 (33).jpg',
    '/assets/img/quick-links/nss/1 (34).jpg',
    '/assets/img/quick-links/nss/1 (35).jpg',
    '/assets/img/quick-links/nss/1 (36).jpg',
    '/assets/img/quick-links/nss/1 (37).jpg',
    '/assets/img/quick-links/nss/1 (38).jpg',
    '/assets/img/quick-links/nss/1 (39).jpg',
    '/assets/img/quick-links/nss/1 (40).jpg',
    '/assets/img/quick-links/nss/1 (41).jpg',
    '/assets/img/quick-links/nss/1 (42).jpg',
    '/assets/img/quick-links/nss/1 (43).jpg',
  ];

  constructor() { }
  ngOnInit(): void { }
}
